// PrivacyPolicy.js
import { Typography, Grid, Icon, Link } from '@mui/material';
import { Security, Storage, Analytics } from '@mui/icons-material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    // padding: theme.spacing(4),
    padding: "1em",
    maxWidth: 1200,
    margin: '0 auto'
  },
  highlight: {
    // backgroundColor: theme.palette?.mode === 'dark' ? '#333' : '#f5f5f5',
    backgroundColor: '#333',
    // padding: theme.spacing(2),
    padding: "1em",
    borderRadius: 4
  }
}));

const PrivacyPolicy = () => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <Typography variant="h3" gutterBottom>
        <Security sx={{ mr: 2 }} />
        Afri-Rate Privacy Policy
      </Typography>

      <Grid container spacing={3}>
        <Grid item xs={12} className={classes.highlight}>
          <Typography variant="h5" gutterBottom>
            <Storage sx={{ mr: 2 }} />
            Data Storage
          </Typography>
          <Typography>
            We store locally in your browser:
            <ul>
              <li>Selected African country</li>
              <li>Preferred stablecoin (USDT/USDC)</li>
              <li>Theme preference</li>
            </ul>
          </Typography>
        </Grid>

        <Grid item xs={12} md={6}>
          <Typography variant="h5" gutterBottom>
            <Analytics sx={{ mr: 2 }} />
            Google Analytics
          </Typography>
          <Typography>
            We collect anonymized usage data to monitor:
            <ul>
              <li>Country selection trends</li>
              <li>Feature engagement</li>
              <li>Performance metrics</li>
            </ul>
          </Typography>
        </Grid>

        <Grid item xs={12} md={6}>
          <Typography variant="h5" gutterBottom>
            <Icon sx={{ mr: 2 }}>📩</Icon>
            Feedback Data
          </Typography>
          <Typography>
            Submitted feedback is stored securely and anonymized. Contact us
            to request data deletion.
          </Typography>
          <Link href="/feedback" sx={{ mt: 2, display: 'block' }}>
            Contact Form
          </Link>
        </Grid>
      </Grid>
    </div>
  );
};

export default PrivacyPolicy;